'use strict';

angular.module('admin').controller('AdminListUsersController',
	['$scope', 'AdminData', 'Authentication', 'Utilities', 'SweetAlert', '$filter', '$timeout',
		function($scope, AdminData, Authentication, Utilities, SweetAlert, $filter, $timeout) {
			$scope.authentication = Authentication;
			$scope.data = {
				textFilter: '',
				users: [],
				activeTab: {
					paying: true,
					restIntegrated: false,
					restNotIntegrated: false
				},
				orderProperties: {
					displayName: {
						name: 'Name',
						reverse: false
					},
					email: {
						name: 'Email',
						reverse: false
					},
					created: {
						name: 'Creation Date',
						reverse: true
					},
					'_info.mau': {
						name: 'MAU',
						reverse: true
					},
					'_info.apiRequests': {
						name: 'API',
						reverse: true
					},
					'_info.teamMembers': {
						name: 'Team Members',
						reverse: true
					},
					'_info.hasBillingData': {
						name: 'Has Billing Data',
						reverse: true
					}
				},
				orderBy: 'created'
			};

			/**
			 * Shows Organization Name input popup
			 */
			$scope.onUserOrganizationClick = function(userId) {
				let user = $scope.data.users.find(item => item._id === userId);
				let formTitle = 'Set Organization Name';

				if(user.organizationName){
					formTitle = formTitle.replace('Set', 'Update');
				}

				SweetAlert.swal(
					{
						title             : formTitle,
						type              : 'input',
						input             : 'text',
						showCancelButton  : true,
						confirmButtonColor: '#DD6B55',
						confirmButtonText : 'Save',
						cancelButtonText  : 'Cancel!',
						closeOnConfirm    : true,
						closeOnCancel     : true
					},
					function (newOrgName) {
						if (newOrgName) {
							const sendData = {
								userId: userId,
								organizationName: newOrgName
							};

							AdminData.updateUser(sendData, function (updatedUser) {
								user.organizationName = updatedUser.organizationName;
								Utilities.showMessage(
									'Success',
									`Organization name '${user.organizationName}' has been saved!`,
									'success'
								);
							}, function (err) {
								let errorMessage = 'There was a problem saving the name';
									if (err.status === 400) {
										errorMessage =  err.data.message;
									}
									$timeout(function() {
										SweetAlert.swal(
											{
												title: 'oops!',
												text: errorMessage,
												type: 'warning',
												showCancelButton: false
											}
										);
									}, 150);
							});
						}
					});

				// Displaying exisiting Orgnaization Name
				if(user.organizationName){
					$timeout(function() {
						$('.sweet-alert input[type="text"]').val(user.organizationName);
					}, 50);
				}
			};

			/**
			 * Returns the filter depending on the current tab selection
			 */
			$scope.getUserFilter = function() {

				var filterQuery = {
					_info: {}
				};
				if ($scope.data.activeTab.paying === true) {
					filterQuery._info.planInfo = {
						id: '!free'
					};
				} else {
					filterQuery._info.planInfo = {
						id: 'free'
					};
				}

				if ($scope.data.activeTab.restIntegrated === true) {
					filterQuery._info.integrated = true;
				} else if ($scope.data.activeTab.restNotIntegrated === true) {
					filterQuery._info.integrated = false;
				}

				return filterQuery;

			};


			/**
			 * Returns the information of the plan as simple string
			 * @param planInfo The information of the plan to get the string of
			 * @returns {string}
			 */
			$scope.getPlanDescription = function(planInfo) {
				var description = 'Apps: ' + planInfo.apps + '\n';
				description += 'Mau: ' + planInfo.mau + '\n';
				description += 'Team Members: ' + planInfo.teamMembers + '\n';
				description += 'API Access: ' + planInfo.apiAccess + '\n';
				description += 'Glossary: ' + planInfo.glossary;

				return description;
			};


			/**
			 * Changes the lock status of the user
			 * @param user The user of which the lock status should be changed
			 * @param newLocked The new lock status
			 */
			$scope.changeUserLock = function(user, newLocked) {

				$timeout(function() {
					var text = 'Are you sure you want to change the locked state for user "' + user.displayName + '" to: ' + newLocked;
					SweetAlert.swal(
						{
							title: 'Change status to: ' + newLocked,
							text: text,
							type: 'warning',
							showCancelButton: true,
							confirmButtonColor: '#DD6B55',
							confirmButtonText: 'Yes!',
							cancelButtonText: 'No!',
							closeOnConfirm: true,
							closeOnCancel: true
						},
						function (isConfirm) {
							if (isConfirm === true) {
								AdminData.changeUserLock({userId: user._id, newLocked: newLocked}, function (data) {
									Utilities.showMessage(
										'Success',
										'The lock status for user "' + user.displayName + '" got set to: ' + newLocked,
										'success'
									);

									// Update the user with the new data
									for (var i=0;i<$scope.data.users.length;i++) {
										if ($scope.data.users[i]._id === data._id) {
											$scope.data.users[i].accountLocked = data.accountLocked;
											break;
										}
									}
								}, function (err) {
									console.log(err);
									Utilities.showMessage(
										'Problem!',
										'Problem changing user lock',
										'error'
									);
								});
							}
						}
					);
				}, 50);
			};


			/**
			 * Delete a user
			 */
			$scope.deleteUser = function(user) {

				// First make sure that we really want to delete teh user
				$timeout(function() {
					var text = 'Are you sure you want to delete the user: "' + user.displayName + '"';
					SweetAlert.swal(
						{
							title: 'Delete user',
							text: text,
							type: 'warning',
							showCancelButton: true,
							confirmButtonColor: '#DD6B55',
							confirmButtonText: 'Yes!',
							cancelButtonText: 'No!',
							closeOnConfirm: true,
							closeOnCancel: true
						},
						function (isConfirm) {
							if (isConfirm === true) {
								// Now actually delete the user
								AdminData.deleteUser({userId: user._id}, function (success) {
									Utilities.showMessage(
										'Success',
										'The user got deleted.',
										'success'
									);

									// Remove the user from the list
									for (var i=0;i<$scope.data.users.length;i++) {
										if ($scope.data.users[i]._id === user._id) {
											$scope.data.users.splice(i, 1);
											break;
										}
									}

								}, function (err) {
									var message = 'Problem deleting the user';
									if (err.data && err.data.message) {
										message = err.data.message;
									}

									Utilities.showMessage(
										'Problem!',
										message,
										'error'
									);
								});
							}
						}
					);
				}, 50);
			};


			/**
			 * Shows all the apps of the user in a popup
			 */
			$scope.showUserApps = function(user) {
				var sortedApps = $filter('orderBy')(user._info.apps, 'name');

				var message = '<div style="text-align: left;"><ul>';
				// user._info.apps.forEach(function(appData) {
				sortedApps.forEach(function(appData) {
					message += '<li><a href="/!/#/projects/' + appData._id + '" target="_blank">' + appData.name + '</a></li>';
				});
				message += '</ul></div>';
				Utilities.showMessage('Projects of ' + user.displayName, message, 'info');
			};


			/**
			 * Shows all the teams of the user in a popup
			 */
			$scope.showUserTeams = function(user) {
				var sortedApps = $filter('orderBy')(user._info.teams, 'name');

				var message = '<div style="text-align: left;"><ul>';
				sortedApps.forEach(function(teamData) {
					var colorClass = 'label-danger';
					if (teamData.role === 'translator') {
						colorClass = 'label-success';
					} else if (teamData.role === 'manager') {
						colorClass = 'label-info';
					} else if (teamData.role === 'admin') {
						colorClass = 'label-warning';
					}
					message += '<li><a href="/#!/teams/' + teamData._id + '" target="_blank">' + teamData.name + '</a><div class="label admin-owner-label ' + colorClass + '">' + teamData.role + '</div></li>';
				});
				message += '</ul></div>';
				Utilities.showMessage('Teams of ' + user.displayName, message, 'info');
			};

			/** 
			 *`Getting team members count excluding TPT user role
			*/
			$scope.getMembersCount = function(teamMembers){
				if(!teamMembers || !teamMembers.length || !Array.isArray(teamMembers)){
					return 0;
				}
				
				var members = teamMembers.filter(function(m){ return m.role && !m.role.toLowerCase().includes('tpt'); });

				if(members){
					return members.length;
				} else {
					return 0;
				}
			};


			/**
			 * Load all the data
			 */
			$scope.init = function() {

				AdminData.getUsers({}, function (users) {
					$scope.data.users = users;
				}, function (err) {
					console.log(err);
					Utilities.showMessage(
						'Problem!',
						'Problem loading user info',
						'error'
					);
				});

			};


			$scope.init();
		}
	]);
